import React from 'react';
import {useQuery} from '@tanstack/react-query';

import {useExperimentsStore} from 'apps/experiments/src/store';
import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {experimentQueryKeyForList} from 'apps/experiments/src/react-query';
import {useExperimentsApi} from 'apps/experiments/src/api/experiments';

import {ListPageTrackingEvent, trackExperimentListPageAction} from '../tracking';

type FetchExperimentListParams = {
  projectId: number;
  workspaceId: number;
};

export function useQueryExperimentList({projectId, workspaceId}: FetchExperimentListParams) {
  const setExperiments = useExperimentsStore((state) => state.setExperiments);
  const reset = useExperimentsStore((state) => state.reset);

  const {listExperiments} = useExperimentsApi({
    projectId,
    workspaceId,
  });

  const {data, isError, error, isSuccess} = useQuery({
    queryKey: experimentQueryKeyForList(projectId, workspaceId),
    queryFn: async () => {
      reset();
      return listExperiments();
    },
  });

  React.useEffect(() => {
    if (isError) {
      addToast({
        message: error.message,
        type: ToastType.ERROR,
      });
    }
  }, [isError, error]);

  React.useEffect(() => {
    if (isSuccess) {
      setExperiments(data || []);
      trackExperimentListPageAction({
        event: ListPageTrackingEvent.ListLoaded,
        props: {
          'experiment count': data?.length,
        },
      });
    }
  }, [isSuccess, data, setExperiments]);
}
